/**
 * Environment Configuration for FOH Client
 * 
 * Centralized configuration for environment variables and feature flags.
 */

// Analytics & Monitoring Configuration
export const ANALYTICS_CONFIG = {
    // Mixpanel
    mixpanel: {
        token: import.meta.env.VITE_MIXPANEL_TOKEN || '',
        enabled: import.meta.env.VITE_ANALYTICS_ENABLED === 'true', // Enabled when flag + token present
        config: {
            debug: import.meta.env.VITE_NODE_ENV === 'development',
            track_pageview: true,
            persistence: 'localStorage',
            ignore_dnt: false,
            // Optional region host override (e.g. https://api-eu.mixpanel.com for EU projects)
            api_host: import.meta.env.VITE_MIXPANEL_API_HOST || undefined,
            loaded: function (_mixpanel) {
                console.log('📊 Mixpanel loaded for FOH Client');
            }
        }
    },

    // Sentry
    sentry: {
        dsn: import.meta.env.VITE_SENTRY_DSN || '',
        enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true' || false, // Can be overridden via env var
        environment: import.meta.env.VITE_NODE_ENV || 'development',
        sampleRate: parseFloat(import.meta.env.VITE_SENTRY_SAMPLE_RATE) || 1.0,
        config: {
            tracesSampleRate: import.meta.env.VITE_NODE_ENV === 'production' ? 0.1 : 1.0,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        }
    }
};

// API Configuration
export const API_CONFIG = {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001',
    apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3001/api',
    timeout: 10000,
    retries: 3
};

// Chatbot Configuration
export const CHATBOT_CONFIG = {
    // Always use the main API proxy endpoint for chatbot to avoid CORS
    endpoint: `${API_CONFIG.apiUrl}/chatbot`,
    enabled: true
};

// Feature Flags
export const FEATURE_FLAGS = {
    enableAnalytics: import.meta.env.VITE_ANALYTICS_ENABLED === 'true',
    enableErrorMonitoring: false, // Will be enabled when implementation is finalized
    enablePerformanceMonitoring: false,
    enableDebugMode: import.meta.env.VITE_NODE_ENV === 'development',
    demoMode: import.meta.env.VITE_DEMO_MODE === 'true'
};

// App Configuration
export const APP_CONFIG = {
    name: 'FOH Ordering System',
    version: '1.0.0',
    environment: import.meta.env.VITE_NODE_ENV || 'development'
};

// Demo specific configuration (only used when FEATURE_FLAGS.demoMode)
export const DEMO_CONFIG = {
    serviceName: import.meta.env.VITE_DEMO_SERVICE_NAME || 'foh_demo'
};

// Supabase (only needed in demo mode for early-access signup)
export const SUPABASE_CONFIG = {
    url: import.meta.env.VITE_SUPABASE_URL || '',
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || ''
};

// Only log in development mode
if (typeof window !== 'undefined' && !window.__SUPABASE_ENV_LOGGED && import.meta.env.VITE_NODE_ENV === 'development') {
    window.__SUPABASE_ENV_LOGGED = true;
    console.info('[Supabase Env] demoMode:', FEATURE_FLAGS.demoMode, 'urlPresent:', !!SUPABASE_CONFIG.url, 'anonKeyPresent:', !!SUPABASE_CONFIG.anonKey);
}
